import React from 'react';
import { DollarSign, PlusCircle, Settings, Download, BarChart, PieChart, AlertTriangle } from 'lucide-react';
export const BudgetTracker: React.FC = () => {
  const budgetSummary = {
    total: 32000,
    spent: 18450,
    remaining: 13550,
    percentUsed: 57.7
  };
  const categories = [{
    name: '場地與餐飲',
    budget: 16000,
    spent: 12000,
    percentUsed: 75,
    color: 'bg-blue-500'
  }, {
    name: '攝影錄影',
    budget: 4000,
    spent: 3500,
    percentUsed: 87.5,
    color: 'bg-green-500'
  }, {
    name: '服飾美容',
    budget: 3000,
    spent: 1800,
    percentUsed: 60,
    color: 'bg-purple-500'
  }, {
    name: '音樂娛樂',
    budget: 3200,
    spent: 800,
    percentUsed: 25,
    color: 'bg-amber-500'
  }, {
    name: '裝飾花藝',
    budget: 2800,
    spent: 350,
    percentUsed: 12.5,
    color: 'bg-pink-500'
  }, {
    name: '交通運輸',
    budget: 1500,
    spent: 0,
    percentUsed: 0,
    color: 'bg-indigo-500'
  }, {
    name: '喜帖文具',
    budget: 1500,
    spent: 0,
    percentUsed: 0,
    color: 'bg-red-500'
  }];
  const recentExpenses = [{
    id: 1,
    name: '場地訂金',
    category: '場地與餐飲',
    amount: 5000,
    date: '2023-04-15',
    status: 'paid'
  }, {
    id: 2,
    name: '餐飲訂金',
    category: '場地與餐飲',
    amount: 3000,
    date: '2023-04-18',
    status: 'paid'
  }, {
    id: 3,
    name: '婚紗禮服',
    category: '服飾美容',
    amount: 1800,
    date: '2023-04-25',
    status: 'paid'
  }, {
    id: 4,
    name: '婚禮攝影',
    category: '攝影錄影',
    amount: 3500,
    date: '2023-05-01',
    status: 'paid'
  }, {
    id: 5,
    name: 'DJ 音響',
    category: '音樂娛樂',
    amount: 800,
    date: '2023-05-05',
    status: 'paid'
  }];
  const upcomingPayments = [{
    id: 1,
    name: '場地尾款',
    category: '場地與餐飲',
    amount: 4000,
    dueDate: '2023-06-15'
  }, {
    id: 2,
    name: '鮮花訂金',
    category: '裝飾花藝',
    amount: 350,
    dueDate: '2023-05-20'
  }];
  return <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <h2 className="text-xl font-semibold">預算追蹤</h2>
        <div className="flex items-center space-x-2">
          <button className="px-4 py-2 border border-border rounded-md bg-white hover:bg-secondary flex items-center space-x-1">
            <Download className="h-4 w-4" />
            <span>匯出</span>
          </button>
          <button className="px-4 py-2 border border-border rounded-md bg-white hover:bg-secondary flex items-center space-x-1">
            <Settings className="h-4 w-4" />
            <span>設定</span>
          </button>
          <button className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 flex items-center space-x-1">
            <PlusCircle className="h-4 w-4" />
            <span>新增支出</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="bg-green-100 p-3 rounded-full">
              <DollarSign className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <h3 className="font-medium">總預算</h3>
              <p className="text-2xl font-semibold">
                ${budgetSummary.total.toLocaleString()}
              </p>
            </div>
          </div>
          <div className="flex flex-col space-y-2">
            <div className="flex justify-between text-sm">
              <span>已支出</span>
              <span className="font-medium">
                ${budgetSummary.spent.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span>剩餘</span>
              <span className="font-medium">
                ${budgetSummary.remaining.toLocaleString()}
              </span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-medium mb-4">預算使用率</h3>
          <div className="flex justify-center mb-2">
            <div className="relative h-24 w-24">
              <svg className="h-24 w-24" viewBox="0 0 36 36">
                <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#E5E7EB" strokeWidth="3" />
                <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#3B82F6" strokeWidth="3" strokeDasharray={`${budgetSummary.percentUsed}, 100`} />
              </svg>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                <div className="text-xl font-semibold">
                  {budgetSummary.percentUsed}%
                </div>
                <div className="text-xs text-muted-foreground">已用</div>
              </div>
            </div>
          </div>
          <div className="text-center text-sm text-muted-foreground">
            ${budgetSummary.spent.toLocaleString()} of $
            {budgetSummary.total.toLocaleString()}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-medium">待付款項</h3>
            <span className="bg-amber-100 text-amber-800 text-xs px-2 py-1 rounded-full">
              {upcomingPayments.length} 筆待付
            </span>
          </div>
          {upcomingPayments.length > 0 ? <ul className="space-y-3">
              {upcomingPayments.map(payment => <li key={payment.id} className="flex justify-between items-center border-b border-border pb-2 last:border-0">
                  <div>
                    <p className="font-medium">{payment.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {payment.category}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium">
                      ${payment.amount.toLocaleString()}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      到期 {new Date(payment.dueDate).toLocaleDateString()}
                    </p>
                  </div>
                </li>)}
            </ul> : <div className="flex flex-col items-center justify-center h-32 text-center">
              <AlertTriangle className="h-8 w-8 text-muted-foreground mb-2" />
              <p className="text-muted-foreground">暫無待付款項</p>
            </div>}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-medium">預算明細</h3>
            <div className="flex items-center space-x-2">
              <button className="p-1 rounded hover:bg-secondary">
                <PieChart className="h-5 w-5" />
              </button>
              <button className="p-1 rounded bg-primary/10 text-primary">
                <BarChart className="h-5 w-5" />
              </button>
            </div>
          </div>
          <div className="space-y-4">
            {categories.map(category => <div key={category.name} className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span>{category.name}</span>
                  <span>
                    ${category.spent.toLocaleString()} / $
                    {category.budget.toLocaleString()}
                  </span>
                </div>
                <div className="w-full bg-secondary rounded-full h-2">
                  <div className={`${category.color} h-2 rounded-full`} style={{
                width: `${category.percentUsed}%`
              }}></div>
                </div>
              </div>)}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-medium mb-4">近期支出</h3>
          <div className="overflow-y-auto max-h-80">
            <table className="min-w-full divide-y divide-border">
              <thead className="bg-secondary">
                <tr>
                  <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    項目
                  </th>
                  <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    分類
                  </th>
                  <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    金額
                  </th>
                  <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    日期
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-border">
                {recentExpenses.map(expense => <tr key={expense.id}>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="font-medium">{expense.name}</div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                      {expense.category}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className="font-medium">
                        ${expense.amount.toLocaleString()}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                      {new Date(expense.date).toLocaleDateString()}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};